// src/WS.js
import axios from "axios";

const BASE_URL = "https://api.glxysims.com"; // Add the 'http://' for a complete URL
// const BASE_URL = "https://glxysims.com/api"; // Add the 'http://' for a complete URL
// const BASE_URL = "http://192.168.0.17:7777"; // Add the 'http://' for a complete URL

const VIDEO_API_URL = `${BASE_URL}/videos`; // Add the 'http://' for a complete URL
const SHORTS_API_URL = `${BASE_URL}/shorts`; // Add the 'http://' for a complete URL
const GALLERY_ITEMS_API_URL = `${BASE_URL}/gallery-items`; // Add the 'http://' for a complete URL

export const WS = {
  getVideos(amount = 10) {
    return axios
      .get(VIDEO_API_URL, { params: { amount } }) // Pass 'amount' as a query parameter
      .then((response) => response.data) // Return the data from the response
      .catch((error) => {
        console.error("Error fetching videos:", error);
        throw error; // Re-throw the error for further handling if necessary
      });
  },
  getShorts(amount = 10) {
    return axios
      .get(SHORTS_API_URL, { params: { amount } }) // Pass 'amount' as a query parameter
      .then((response) => response.data) // Return the data from the response
      .catch((error) => {
        console.error("Error fetching shorts:", error);
        throw error; // Re-throw the error for further handling if necessary
      });
  },
  getImage(filename) {
    return `${BASE_URL}/images/${filename}`;
  },

  getGalleryItems() {
    return axios
      .get(GALLERY_ITEMS_API_URL)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error loading gallery items:", error);
        throw error;
      });
  },
  recordUsage(videoUrl) {
    let url = `${BASE_URL}/click`;
    if (videoUrl) {
      url += `?video_url=${encodeURIComponent(videoUrl)}`;
    }

    return axios.post(url).catch((error) => {
      console.error("Error recording usage:", error);
      throw error;
    });
  },
};
